import {updateQueryStringParam} from "../Utils/Utils.js";

const ACFBlockPressReleases = (domEl) => {

	const yearSelection = domEl.querySelector('#year-selection');
	const newsItems = domEl.querySelectorAll('.news-item');

	const renderNewsItems = (year) => {
		newsItems.forEach(newsItem => {

			if(year === 'all') {
				newsItem.classList.add('js-active');
			}
			else {
				if(parseInt(newsItem.dataset.year) === year) {
					newsItem.classList.add('js-active');
				}
				else {
					newsItem.classList.remove('js-active');
				}
			}
		});
	};

	const handleYearChange = (e) => {
		e.preventDefault();

		const year = e.currentTarget.value
		if(!year) {
			return;
		}

		// Get the options selected and update the urlParams
		if(history.pushState) {

			// Update the urlParams
			const uri = updateQueryStringParam('y', year);
			window.history.replaceState({path:uri},'',uri);
		}

		renderNewsItems(year === 'all' ? year : parseInt(year));
	};

	yearSelection.addEventListener('change', handleYearChange);
};

export default ACFBlockPressReleases;